import { render, staticRenderFns } from "./OwnerNotificationDetailPage.vue?vue&type=template&id=54f8c719&"
import script from "./OwnerNotificationDetailPage.vue?vue&type=script&lang=ts&"
export * from "./OwnerNotificationDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
